import { useCallback, useMemo, useState } from 'react';

const readStoredKeys = (storageKey) => {
  try {
    const parsed = JSON.parse(window.localStorage.getItem(storageKey));
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

// Hidden keys are stored (not visible keys) so columns added later show by default.
export default function useStoredHiddenColumns(storageKey) {
  const [hiddenKeys, setHiddenKeys] = useState(() => readStoredKeys(storageKey));

  const onToggleColumn = useCallback((columnKey) => (visible) => {
    setHiddenKeys((prev) => {
      const next = visible
        ? prev.filter((key) => key !== columnKey)
        : [...new Set([...prev, columnKey])];
      try {
        window.localStorage.setItem(storageKey, JSON.stringify(next));
      } catch {
        //
      }
      return next;
    });
  }, [storageKey]);

  const hiddenKeySet = useMemo(() => new Set(hiddenKeys), [hiddenKeys]);

  return { hiddenKeySet, onToggleColumn };
}
